import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { LEGAL_DETAILS, privacyMailto } from '../config/legal';
import { useI18n } from '../i18n/I18nContext';
import { getLegalCopy } from '../i18n/legalCopy';
import '../style/Homepage.css';

const AccountPrivacyPage = () => {
  const { language } = useI18n();
  const { account: copy } = getLegalCopy(language);

  return (
    <div>
      <Header />
      <main className="info-page account-privacy-page">
        <section className="info-hero">
          <p className="eyebrow">{copy.eyebrow}</p>
          <h1>{copy.title}</h1>
          <p>{copy.intro}</p>
          <div className="hero-actions">
            <Link to="/contact?topic=privacy" className="primary-button">{copy.request}</Link>
            <Link to="/privacy" className="secondary-button">{copy.read}</Link>
          </div>
        </section>

        <section className="feature-grid info-grid privacy-grid" aria-label={copy.summaryLabel}>
          {copy.cards.map(([title, body]) => (
            <article className="feature-card" key={title}>
              <h3>{title}</h3>
              <p>{body}</p>
            </article>
          ))}
        </section>

        <section className="privacy-account-flow" aria-label={copy.flowLabel}>
          <div className="section-heading">
            <p className="eyebrow">{copy.flowEyebrow}</p>
            <h2>{copy.flowTitle}</h2>
          </div>
          <div className="privacy-step-grid">
            {copy.steps.map(([title, body], index) => (
              <article key={title}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                <div><h3>{title}</h3><p>{body}</p></div>
              </article>
            ))}
          </div>
        </section>

        <section className="terms-content" aria-label={copy.controlsLabel}>
          {copy.controls.map(([title, paragraphs]) => (
            <article className="terms-section-card" key={title}>
              <h2>{title}</h2>
              <div>{paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}</div>
            </article>
          ))}
        </section>

        <section className="terms-contact-card">
          <div><p className="eyebrow">{copy.contactEyebrow}</p><h2>{copy.contactTitle}</h2></div>
          <p>{copy.contactBody} <a href={privacyMailto}>{LEGAL_DETAILS.privacyEmail}</a>{' '}
            <Link to="/contact?topic=privacy">{copy.form}</Link>.
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AccountPrivacyPage;
